import React, { memo, useEffect, useState, useRef } from 'react';
import { Picker as OldPicker, Modal, PickerView, Toast } from 'antd-mobile';
import { translationByCallBack } from 'config/language/context';
import styles from './index.modules.less';

// Picker HOC 转换多语言
const Dom = memo((props) => {
  const {
    title, // String 大标题
    okText, // String 选中的文案 默认为确定
    dismissText, // String 取消选中的文案 默认为取消
    ...restProps
  } = props;

  const [newTitle, setNewTitle] = useState(title);
  const [newOkText, setNewOkText] = useState(okText);
  const [newDismissText, setNewDismissText] = useState(dismissText);

  useEffect(() => {
    translationByCallBack(title, setNewTitle);
  }, [title]);

  useEffect(() => {
    translationByCallBack(okText, setNewOkText);
  }, [okText]);

  useEffect(() => {
    translationByCallBack(dismissText, setNewDismissText);
  }, [dismissText]);

  return (
    <OldPicker title={newTitle} okText={newOkText} dismissText={newDismissText} {...restProps} />
  );
});

const SearchPicker = memo((props) => {
  const {
    okText, // String 选中的文案 默认为确定
    dismissText, // String 取消选中的文案 默认为取消
    title, // String 大标题
    onSearch,
    data,
    value,
    onChange,
    visible: propsVisible,
    onOk,
    onDismiss,
    searchKey,
    ...restProps
  } = props;
  console.log('props>>>>>', props);
  // Number 防抖延迟时间，默认500ms
  const debounceDelay = 500;
  // 内部维护visible状态，但也响应props变化
  const [visible, setVisible] = useState(propsVisible || false);
  const [pickerData, setPickerData] = useState(data || []);
  const debounceTimer = useRef(null);
  const pickerValue = useRef(null);

  // 当props.visible变化时，更新内部visible状态
  useEffect(() => {
    setVisible(propsVisible);
  }, [propsVisible]);

  useEffect(() => {
    setPickerData(data || []);
  }, [data]);

  useEffect(() => {
    pickerValue.current = value || [];
  }, [value]);

  // 防抖处理函数
  const handleSearch = (value) => {
    // 清除之前的定时器
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // 设置新的定时器
    debounceTimer.current = setTimeout(() => {
      // 执行搜索操作
      if (onSearch) {
        onSearch(value);
      } else {
        const newData = data.filter((item) => {
          return (searchKey || []).some((_) => item[_].includes(value));
        });
        setPickerData([]);
        setPickerData(newData);
      }
    }, debounceDelay);
  };

  // 处理关闭事件
  const handleClose = () => {
    setVisible(false);
    setPickerData(data);
    if (onDismiss) {
      onDismiss();
    }
  };

  // 处理确定事件
  const handleOk = () => {
    if (pickerValue.current && pickerData.length > 0) {
      setVisible(false);
      let areaCode = pickerValue.current;
      if (typeof areaCode == 'string') {
        areaCode = [pickerValue.current];
      }
      if (onOk) {
        onOk(areaCode);
      }
      if (onChange) {
        onChange(areaCode);
      }
    } else {
      Toast.info('请选择对应选项');
    }
    setPickerData(data);
  };

  const handleChange = (value) => {
    pickerValue.current = value;
  };

  return (
    <React.Fragment>
      <div onClick={() => setVisible(true)}>{props.children}</div>
      <Modal popup onClose={handleClose} animationType="slide-up" visible={visible}>
        <div>
          <div className={styles['modal-picker-header']}>
            <span className={styles['modal-picker-header-left']} onClick={handleClose}>
              {dismissText || '取消'}
            </span>
            <span className={styles['modal-picker-header-title']}>{title}</span>
            <span className={styles['modal-picker-header-right']} onClick={handleOk}>
              {okText || '确定'}
            </span>
          </div>
          <input
            placeholder={props.searchPlaceholder || '请输入'}
            className={styles['modal-picker-search-input']}
            onChange={(e) => {
              const value = e.target.value;
              handleSearch(value);
            }}
          />
          {pickerData && pickerData.length > 0 ? (
            <PickerView
              data={pickerData}
              value={Array.isArray(value) ? value : [value]}
              onChange={(value) => handleChange(value)}
              {...restProps}
            />
          ) : (
            <div className={styles['modal-picker-no-data']}>没有你想要的数据</div>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
});

const Picker = memo((props) => {
  const {
    okText, // String 选中的文案 默认为确定
    dismissText, // String 取消选中的文案 默认为取消
    title, // String 大标题
    onSearch,
    showSearch = false, // Boolean 是否显示搜索框
    ...restProps
  } = props;

  const renderTitle = () => {
    if (typeof title == 'string') {
      return (
        <div>
          <span className="ellipsis-one">{title}</span>
        </div>
      );
    }
    return title;
  };

  const getTitle = renderTitle();
  if (showSearch) {
    return <SearchPicker {...props} />;
  }

  return (
    <Dom
      okText={props.newOkText || '确定'}
      dismissText={props.newDismissText || '取消'}
      title={getTitle}
      {...restProps}
    />
  );
});

export default Picker;



// WEBPACK FOOTER //
// ./src/widget/Picker/index.js